import React from 'react';
const rows = [{
  problem: '2 hours of prep per client, every week',
  cost: '100+ unpaid hours a year'
}, {
  problem: 'Hunting for exercises on Google & YouTube',
  cost: 'Sessions with no coherence'
}, {
  problem: 'A client who doesn’t perceive a method',
  cost: 'Drops off by month two — you lose $100–300 per client'
}, {
  problem: 'Insecurity before every session',
  cost: 'You charge less than you’re worth'
}, {
  problem: 'An improvised session',
  cost: 'Your reputation on the line every time'
}];
export function CostOfInaction() {
  return <section aria-labelledby="cost-heading" className="w-full bg-cream" data-id="element-69" data-mp="3do23rna8u701">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-70" data-mp="3in58f6mbab7h">
        <h2 id="cost-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-71" data-mp="3ipiyf124wx86">
          <span aria-hidden="true" data-id="element-72" data-mp="3sl2tjl8vjrvv">💸</span> What does it cost to keep winging
          it?
        </h2>

        <div className="mt-8 overflow-hidden rounded-2xl border border-cream-dark shadow-card" data-id="element-73" data-mp="3egzkn42uvey3">
          <table className="w-full text-left" data-id="element-74" data-mp="39gtwvyzpicla">
            <thead data-id="element-75" data-mp="39g222qdxoiw2">
              <tr data-id="element-76" data-mp="39jputnbk119q">
                <th className="w-1/2 bg-danger-soft px-4 sm:px-6 py-3.5 text-xs uppercase tracking-[0.12em] font-bold text-danger" data-id="element-77" data-mp="34i0lqd7w6xoa">
                  Without the System
                </th>
                <th className="w-1/2 bg-cream-dark px-4 sm:px-6 py-3.5 text-xs uppercase tracking-[0.12em] font-bold text-ink" data-id="element-78" data-mp="11jwcvbgtffm">
                  The real cost
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-cream-dark" data-id="element-79" data-mp="3ngmnlub8gst9">
              {rows.map(row => <tr key={row.problem} className="bg-white align-top" data-id="element-80" data-mp="3jg2owmb0hh50">
                  <td className="px-4 sm:px-6 py-4 text-[14px] sm:text-[15px] text-ink-soft" data-id="element-81" data-mp="3jdq5s5tip0qd">
                    <span className="text-danger mr-1.5" aria-hidden="true" data-id="element-82" data-mp="jtw1fpti6utg">
                      ✕
                    </span>
                    {row.problem}
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-[14px] sm:text-[15px] font-semibold text-ink" data-id="element-83" data-mp="299yhyryewz6q">
                    {row.cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mt-9 text-center font-serif font-bold text-lg sm:text-2xl text-ink" data-id="element-84" data-mp="24hydqnbb7k4c">
          Your next client could experience something completely different.
        </p>
        <blockquote className="mt-5 mx-auto max-w-2xl rounded-2xl bg-sage-tint border-l-4 border-sage px-6 py-5 text-center" data-id="element-85" data-mp="1vhs45ciqf4ag">
          <p className="font-serif italic text-lg sm:text-xl text-sage" data-id="element-86" data-mp="1glaucpq6xxq0">
            “Your next session could be the best one you’ve ever run.”
          </p>
        </blockquote>
      </div>
    </section>;
}